import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";
import AirplanemodeActiveIcon from "@mui/icons-material/AirplanemodeActive";
import VideocamIcon from "@mui/icons-material/Videocam";
import CameraAltIcon from '@mui/icons-material/CameraAlt';

export const DroneIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" sx={{ stroke: "currentColor" }} {...props}>
    <g fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
      {/* Arms */}
      <path d="M12 12L8.5 8.5M12 12l3.5-3.5M12 12l3.5 3.5M12 12L8.5 15.5" />
      {/* Body */}
      <rect x="9" y="9" width="6" height="6" rx="2" />
      {/* Rotors */}
      <circle cx="6" cy="6" r="2.4" />
      <circle cx="18" cy="6" r="2.4" />
      <circle cx="6" cy="18" r="2.4" />
      <circle cx="18" cy="18" r="2.4" />
    </g>
  </SvgIcon>
);

export const HelicopterIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round">
      {/* Main rotor */}
      <path d="M3 5.5h18" />
      {/* Rotor mast */}
      <path d="M12 5.5v3" />
      {/* Fuselage + cabin */}
      <path d="M4 12h9a4 4 0 0 1 4 4v2H6a2 2 0 0 1-2-2v-4z" />
      {/* Cockpit window */}
      <path d="M7.5 13.5H11a1.75 1.75 0 0 1 1.75 1.75V18H7.5v-4.5z" />
      {/* Tail boom */}
      <path d="M17 16h3.5" />
      {/* Tail rotor (small cross) */}
      <path d="M21 14.5l1.4.8M22.4 13.7l-1.4.8M21 14.5l-1.4-.8M19.6 15.3l1.4-.8" />
      {/* Skids */}
      <path d="M6 18l-2 2" />
      <path d="M14 18l-2 2" />
      <path d="M3 20h12" />
    </g>
  </SvgIcon>
);

export const PLATFORM_TYPE_ICONS: Record<string, any> = {
  Quadcopter: DroneIcon,
  Plane: AirplanemodeActiveIcon,
  Helicopter: HelicopterIcon,
  Camera: VideocamIcon,
  Other: CameraAltIcon
};

export const getPlatformIcon = (type: string) => {
  const normalizedType = type.trim();
  return PLATFORM_TYPE_ICONS[normalizedType] || VideocamIcon;
};
